export const dateFormat = {
    padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    },
    formatDate(date = new Date()) {
        return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
        ].join('-');
    },

    //получение текущей даты по Москве
    getDateNowWithTimeZone(timeZone = "Europe/Moscow") {
        let
            date = new Date().toLocaleString("ru-RU", {timeZone: timeZone})
            , dt = date.split(', ')
            , iso = dt[0].split('.').reverse().join('-') + 'T' + dt[1]
        return new Date(iso)
    },

    strToFormat(date) {
        let stamp = Date.parse(date)
        return this.formatDateView(new Date(stamp))
    },

    formatDateView(date) {

        var dd = date.getDate();
        if (dd < 10) dd = '0' + dd;

        var mm = date.getMonth() + 1;
        if (mm < 10) mm = '0' + mm;

        var yy = date.getFullYear() //% 100;
        // if (yy < 10) yy = '0' + yy;

        return dd + '.' + mm + '.' + yy;
    },
    // сравнивает даты
    compare(date1,date2){
        let d1= new Date(date1).getTime()
            , d2 = new Date(date2).getTime()

        if(d1 === d2){
            return '='
        }else if(d1 > d2){
            return '>'
        }else{
            return '<'
        }
    }

}